import React from 'react'
import { Collapse, Tag,Button,notification } from 'antd'
import ReactHtmlParser from 'react-html-parser'
import { useDispatch } from 'react-redux';
import { RowTable } from '../../article/articleView/RowTable'
import { getPushPathWrapper } from '../../../routes'
import { SendAbstractEmailAction } from '../actions'
import { chooseEmailModalFxn } from '../../../components/_utils/appUtils'


const { Panel } = Collapse

const AbstractDetails = (props) => {
  let { abstract,BtnAction,reload } = props
  const dispatch = useDispatch();
  const sendMailFxn = () => {
    chooseEmailModalFxn({
      title: 'Resend Acknowledgment',
      callback: async (email) => {
        let obj = {
          id: abstract._id,
          fromEmail: email,
          emailType: 'acknowledgement',
          template: 'abstractAcknowledgement',
          type: 'abstract',
          model: 'Abstract',
          status: 'Absrtact Acknowledgement'
        };

        let resp = await dispatch(
          SendAbstractEmailAction({ id: abstract._id, obj })
        );

        if (resp && resp.success) {
          notification.success({ message: 'Success', description: 'Acknowledgment sent successfully' });
          if (reload) reload();
        }
      }
    });
  }

  const getKeywords = (kw) => {
    if (Array.isArray(kw)) return kw
    if (typeof kw === 'string') return kw.split(',').map(k => k.trim())
    return []
  }
  const getExtraButton = () => (
    <div style={{ display: 'flex', gap: '8px' }}>
      {!abstract.acknowledgmentDate && !abstract.paymentDate ? (
        <Button type={'primary'} size={'small'} onClick={sendMailFxn}>
          Resend Ack.
        </Button>
      ) : null}
      <Button
        type={'primary'}
        size={'small'}
        onClick={() => {
          dispatch(
            getPushPathWrapper('onlineAbstractsGroup.approvedEdit', {
              id: abstract._id
            })
          )
        }}
      >
        Edit
      </Button>
    </div>
  )
  return (
    abstract && abstract._id ? (
      <Collapse defaultActiveKey={['1', '2']} expandIconPosition={'right'}>
        {/* Section 1: Abstract Information */}
        <Panel header='Abstract Details' key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Abstract ID'} value={abstract.onlineAbstractId} />
            <RowTable title={'Abstract Title'} value={ReactHtmlParser(abstract.titleOfAbstract)} />
            <RowTable title={'Journal'} value={abstract.journal.name} />
            <RowTable title={'Country'} value={abstract.country} />
            <RowTable title={'Issue Type'} value={abstract.issueType} />
            <RowTable title={'Research Area'} value={abstract.researchArea} />
            <RowTable title={'Speaker Note'} value={abstract.speakerNote} />
            <RowTable title={'Publication Charges'} value={abstract.publicationCharges} />
            <RowTable title={'Currenty Type'} value={abstract.currency} />
            <RowTable title={'Abstract'} value={
              <div style={{ width: '75%'}}>
                {ReactHtmlParser(abstract.abstract)}
              </div>
            } />

            {/* Updated Keywords Section */}
            <RowTable
              title={'Keywords'}
              value={
                <div>
                  {(getKeywords(abstract.keywords)).map((k, i) => (
                    <Tag key={i} color='blue' style={{ marginBottom: '5px' }}>{k}</Tag>
                  ))}
                </div>
              }
            />
          </div>
        </Panel>

        <Panel header='Author Details' key='2'>
          <div className={'tableBox striped'}>
            <RowTable title={'Name'} value={abstract.authorName} />
            <RowTable title={'Email'} value={abstract.email} />
            <RowTable title={'Contact Number'} value={abstract.mobile} />
            <RowTable title={'Institute Affiliated'} value={abstract.institution} />
            <RowTable title={'Designation'} value={abstract.designation} />
            <RowTable title={'Country'} value={abstract.country} />
          </div>
        </Panel>

        {abstract.coAuthors && abstract.coAuthors.length > 0 && (
          <Panel header='Co-Authors' key='3'>
            {abstract.coAuthors.map((co, index) => (
              <div key={index} style={{ marginBottom: '20px', borderBottom: '1px solid #f0f0f0' }}>
                <div className={'tableBox striped'}>
                  <RowTable title={`Name (${index + 1})`} value={co.name} />
                  <RowTable title={'Email'} value={co.email} />
                  <RowTable title={'Affiliation'} value={co.affiliation} />
                  <RowTable title={'Country'} value={co.country} />
                  <RowTable title={'ORCID ID'} value={co.orcidId} />
                </div>
              </div>
            ))}
          </Panel>
        )}
      </Collapse>
    ) : null
  )
}

export default AbstractDetails
